import { AppHeader } from './components/AppHeader/appHeader';
import React,{useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UncontrolledTooltip } from 'reactstrap'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import Report from './components/Report/report'
import Assistant from './components/Assistant/assistant';
import jwt_decode from "jwt-decode";


const DefaultContainer = React.memo((props) => {
    const [isSidebarOpen,setSideBarOpen]=useState(false)
    const [isReportModalOpen, setisReportModalOpen] = useState(false)
    const [isWikiSidebar, setWikiSidebar] = useState(false);

    const report = () =>{
      setisReportModalOpen(!isReportModalOpen)
    }
    
    return (
        <div>
            <AppHeader setSideBarOpen={setSideBarOpen} isSidebarOpen={isSidebarOpen} setWikiSidebar={setWikiSidebar} isWikiSidebar={isWikiSidebar}/>
            <Report isReportModalOpen={isReportModalOpen} report={report}/>
            <Assistant />
            <div className="content" onClick={() => setSideBarOpen(false)}>
                <footer>
                  {localStorage.getItem("guest") &&
                  <a href="mailto:DNAPathoTracker@eurofins.com?cc=food-web@eurofins.de&subject= Enquiry from DNAPathotracker Guest Login">
                  <div className='contact-us-div'>
                    <FontAwesomeIcon id="ContactUs" className='contact-us-svg' icon={faEnvelope} size="3x" />
                    <UncontrolledTooltip placement="left" target="ContactUs"> Contact Us</UncontrolledTooltip>
                    </div></a>}
                    {/* <div className="bottom-text">© Eurofins Genomics 2020</div> */}
                </footer>
            </div>
        </div>
    );
})

export default DefaultContainer;